// Die Seiten des Argus-Moduls (docs/argus-modul.md). lib/routes.ts hängt
// diesen Abschnitt ein (eine Zeile); die Bereichs-Zeile steht in
// lib/nav-sections.ts. internal/navcheck liest auch diese Datei.
//
// /argus ist wie bei jedem Bereich die Telefon-Übersicht; am Schreibtisch
// zeigt der Pfad den Baum. Ein Stand ist ein Register von „Bilder prüfen"
// (gleicher Tab, der Baum markiert ihn), Hailo und Schattenbetrieb sind
// Register von „Modelle".

import type { RouteSection } from "../../lib/routes";

export const argusRouten: RouteSection = {
  title: "Argus",
  items: [
    {
      path: "/argus",
      label: "Argus",
      component: () => import("../../pages/BereichsUebersicht.svelte"),
      aliases: ["Modellbau", "eigenes Modell", "Kamerasystem", "Erkennung", "YOLO"],
    },
    {
      path: "/argus/uebersicht",
      label: "Übersicht",
      component: () => import("./Uebersicht.svelte"),
      hidden: true,
      aliases: ["Argus Übersicht", "Modellbau", "Kette", "Vom Bild zum Modell"],
    },
    {
      path: "/argus/sammeln",
      label: "Sammeln",
      component: () => import("./Sammeln.svelte"),
      hidden: true,
      aliases: ["Sammellauf", "Nachtlauf", "aktives Lernen", "neue Bilder", "bilder.py"],
    },
    {
      path: "/argus/pruefen",
      label: "Bilder prüfen",
      component: () => import("./Pruefen.svelte"),
      hidden: true,
      aliases: ["Prüfen", "Prüfansicht", "Beschriften", "Labeln", "Labeling", "Kästen", "Urteile", "Datensatz"],
    },
    {
      path: "/argus/pruefen/:stand",
      tabWurzel: "/argus/pruefen",
      label: "Stand",
      component: () => import("./Pruefen.svelte"),
      hidden: true,
      inMenu: false,
    },
    {
      path: "/argus/training",
      label: "Training",
      component: () => import("./Training.svelte"),
      hidden: true,
      aliases: ["Trainieren", "RunPod", "GPU", "Grafikkarte", "Lauf", "Epochen", "mAP"],
    },
    {
      path: "/argus/modelle",
      label: "Modelle",
      component: () => import("./Modelle.svelte"),
      hidden: true,
      aliases: ["Modell", "ONNX", "HEF"],
    },
    {
      path: "/argus/modelle/hailo",
      tabWurzel: "/argus/modelle",
      label: "Hailo (HEF)",
      component: () => import("./Modelle.svelte"),
      hidden: true,
      inMenu: false,
      aliases: ["Hailo", "HEF", "Hailo-8", "Umwandlung", "DFC"],
    },
    {
      path: "/argus/modelle/schatten",
      tabWurzel: "/argus/modelle",
      label: "Schattenbetrieb",
      component: () => import("./Modelle.svelte"),
      hidden: true,
      inMenu: false,
      aliases: ["Schatten", "Kandidat"],
    },
    {
      path: "/argus/einstellungen",
      label: "Einstellungen",
      component: () => import("./Einstellungen.svelte"),
      hidden: true,
      aliases: ["Argus Einstellungen", "Ablage", "Modul"],
    },
  ],
};

/** Was die Suche zu den Seiten wissen soll (lib/routes.ts, routeIntents). */
export const argusAbsichten: Record<string, string> = {
  "/argus": "Argus, eigenes Erkennungsmodell bauen, Bilder prüfen, trainieren, Modelle für den Hailo",
  "/argus/uebersicht": "wie weit ist das eigene Modell, Kette vom Bild zum Modell, was ist geplant, was kostet das Training, welches Modell läuft",
  "/argus/sammeln": "jede Nacht neue Bilder vom Vortag sammeln, welches Modell wählt aus, wann kommt der nächste Stand, warum keine neuen Bilder",
  "/argus/pruefen": "Kamerabilder prüfen und beschriften, Kästen ziehen, Klassen setzen, Bilder verwerfen, offene Bilder",
  "/argus/training": "Training starten, heute Nacht planen, Training beenden, läuft das Training, Epoche, mAP, Kosten auf RunPod, Protokoll",
  "/argus/modelle": "fertige Modelle, HEF für den Hailo, Schattenbetrieb, welches Modell ist das beste",
  "/argus/einstellungen": "Ablage des Modellbaus, Datenpfad, RunPod-Schlüssel, Abgleich mit homeserver2",
};
